import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';
import { useTranslation } from '../../i18n';
import styles from './Charts.module.css';

interface Props {
  data: Array<{ category: string; value: string }>;
}

export function ValueByCategoryChart({ data }: Props) {
  const { t } = useTranslation();

  if (data.length === 0) {
    return <div className={styles.empty}>{t('stats.noData')}</div>;
  }

  const parsed = data.map((d) => ({
    category: d.category,
    value: parseFloat(d.value) || 0,
  }));

  return (
    <div className={styles.chartCard}>
      <h3 className={styles.chartTitle}>{t('stats.valueByCategory')}</h3>
      <div className={styles.chartWrap}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={parsed}
            layout="vertical"
            margin={{ top: 8, right: 8, bottom: 8, left: 80 }}
          >
            <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" horizontal={false} />
            <XAxis
              type="number"
              tick={{ fill: 'var(--text-secondary)', fontSize: 11 }}
              axisLine={{ stroke: 'var(--border)' }}
              tickLine={false}
              tickFormatter={(v) => `$${v.toLocaleString()}`}
            />
            <YAxis
              type="category"
              dataKey="category"
              tick={{ fill: 'var(--text-secondary)', fontSize: 11 }}
              axisLine={{ stroke: 'var(--border)' }}
              tickLine={false}
              width={75}
            />
            <Tooltip
              cursor={{ fill: 'var(--accent)', opacity: 0.08 }}
              contentStyle={{
                background: 'var(--bg-secondary)',
                border: '1px solid var(--border)',
                borderRadius: 'var(--radius-sm)',
                color: 'var(--text-primary)',
                fontSize: '0.75rem',
              }}
              formatter={(value: number | undefined) => [`$${(value ?? 0).toLocaleString()}`, 'Value']}
            />
            <Bar dataKey="value" fill="var(--accent)" radius={[0, 4, 4, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
